module.exports = __webpack_public_path__ + "img/fli_logo.a1ee04f3.png";